import { MenuItemCardProps } from '@/renderer/types/sales';
import React from 'react';

export const MenuItemCard: React.FC<MenuItemCardProps> = ({
  item,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      className={`flex min-h-[86px] flex-col justify-between border-b border-r border-gray-200 p-3 text-left transition-colors ${
        disabled
          ? 'cursor-not-allowed bg-gray-50 opacity-70'
          : 'bg-white hover:bg-gray-50'
      }`}
      onClick={() => onClick(item)}
      disabled={disabled}
      title={item.name}
    >
      <span className="app-item-name line-clamp-2">{item.name}</span>
      <span className="text-sm font-bold text-emerald-700 leading-none">
        {item.base_price.toLocaleString()}
      </span>
    </button>
  );
};
